import { useRouter } from 'next/router';

export const useIsOrderReceiptPage = () => {
  const router = useRouter();

  return router.route === '/[locationSlug]/[merchantSlug]/[merchantId]/order/[orderId]';
};
